import { GenerateModalWithSuspense } from "@libs/modal-panels/modal-registry-helpers";
import { iModalProps } from "@libs/modal-panels/modal-registry-model";
import React from "react";

const ViewWACampaignReportModal = React.lazy(
  () => import("./view-wa-campaign-report.modal"),
);

const ViewWACampaignReport: iModalProps<
  typeof ViewWACampaignReportModal,
  {
    campaignId: string;
  }
> = {
  name: "wa-marketing-campaign-report",
  component: GenerateModalWithSuspense(ViewWACampaignReportModal),
};

export default ViewWACampaignReport;
